module.exports = __webpack_public_path__ + "img/9788954650212.599c3b4e.jpg";